module.exports = __webpack_public_path__ + "img/技能大赛@2x.78544558.png";